import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';

import AuthContext from '../../App/authContext';

class SidebarContent extends Component {
  static propTypes = {
    changeToDark: PropTypes.func.isRequired,
    changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };

  render() {
    return (
      <AuthContext.Consumer>
        {
          value => (
            <div className="sidebar__content">
              <ul className="sidebar__block">
                <SidebarLink title="Log out" icon="exit" route="/login" onClick={() => {
                  this.hideSidebar();
                  localStorage.clear();
                  value();
                }} />
              </ul>
              { localStorage.getItem('type') == 0 ?
                <ul className="sidebar__block">
                  <SidebarLink title="Project" route="/projects" onClick={this.hideSidebar} />
                  <SidebarLink title="Sticker" route="/stickers" onClick={this.hideSidebar} />
                  <SidebarLink title="Stats" route="/stats" onClick={this.hideSidebar} />
                  <SidebarLink title="Project Category" route="/project-category" onClick={this.hideSidebar} />
                  <SidebarLink title="Sticker Category" route="/sticker-category" onClick={this.hideSidebar} />
                  <SidebarLink title="User" route="/users" onClick={this.hideSidebar} />
                  <SidebarLink title="Sticker Review" route="/sticker-review" onClick={this.hideSidebar} />
                  <SidebarLink title="Links" route="/links" onClick={this.hideSidebar} />
                  <SidebarLink title="Fonts" route="/fonts" onClick={this.hideSidebar} />
                  <SidebarLink title="Promo Code" route="/promo-code" onClick={this.hideSidebar} />
                  {/* <SidebarLink title="Link Detail" route="/link-detail" onClick={this.hideSidebar} /> */}
                </ul> : 
                <ul className="sidebar__block">
                  <SidebarLink title="User" route="/users" onClick={this.hideSidebar} />
                {/* <SidebarLink title="Sticker" route="/add-sticker" onClick={this.hideSidebar} /> */}
              </ul>}
            </div>
          )
        }
      </AuthContext.Consumer>
    );
  }
}

export default SidebarContent;
